import {
  Box,
  Button,
  Heading,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

interface GetStartedProps {
  onContinue: () => void;
}

export const GetStartedDirectPayments: React.FC<GetStartedProps> = ({
  onContinue,
}) => {
  const { t } = useTranslation();
  const textColor = useColorModeValue("navy.700", "white");

  return (
    <Box me="auto">
      <Heading color={textColor} fontSize="24px" mb="10px">
        {t("usd_payments")}
      </Heading>
      <Text fontSize="md" mb={3}>
        {t("how_it_works_direct_description")}
      </Text>
      <ul style={{ marginLeft: "20px", marginBottom: "12px" }}>
        <li>
          <b>{t("step_1_direct_title")}</b> {t("step_1_direct")}
        </li>
        <li>
          <b>{t("step_2_direct_title")}</b> {t("step_2_direct")}
        </li>
        {/* <li>
          <b>{t("step_3_direct_title")}</b> {t("step_3_direct")}
        </li> */}
        <li>
          <b>{t("step_4_direct_title")}</b> {t("step_4_direct")}
        </li>
      </ul>
      <Text fontSize="md" mb={5}>
        {t("complete_id_verification")}
      </Text>
      <Button colorScheme="blue" variant="solid" onClick={onContinue}>
        {t("get_started_direct")}
      </Button>
    </Box>
  );
};
